import i from "./highrise1337.mjs";
import t from "./highrise1418.mjs";
function f(r) {
  return t(r) && i(r);
}
export {
  f as default
};
